import React, { useCallback } from "react"
import { connect } from "react-redux"
import { Navigate } from "react-router-dom"
import { updateSession, clearSession } from "../../Redux/sessionSlice"

import EdianLogo from '../../assets/edian.png'
import AwsLogo from '../../assets/aws.png'
import OllamaLogo from '../../assets/ollama.webp'
import EsLogo from '../../assets/es.png'
import ReactLogo from '../../assets/react.png'
import PythonLogo from '../../assets/python.webp'
import GolangLogo from '../../assets/golang.png'
import GitlabLogo from '../../assets/gitlab.png'
import AvinLogo from '../../assets/avin.jpg'
import FlutterLogo from '../../assets/flutter.jpg'
import GeminiLogo from '../../assets/gemini.png'
import HashicorpLogo from '../../assets/hashicorp.webp'
import AndroidLogo from '../../assets/android.svg'
import IosLogo from '../../assets/ios.png'
import TalentFit01 from '../../assets/talentfit_01.jpg'
import TalentFit02 from '../../assets/talentfit_02.jpg'
import Orbiter01 from '../../assets/orbiter_01.png'
import Orbiter02 from '../../assets/orbiter_02.png'
import WarGauge01 from '../../assets/wargauge_01.jpeg'
import WarGauge02 from '../../assets/wargauge_02.png'
import GizmoDocs01 from '../../assets/gizmodocs_01.jpg'
import GizmoDocs02 from '../../assets/gizmodocs_02.jpg'


import "./LandingPage.css";
import { avatarClasses } from "@mui/material"


class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: null,
    };
  }

  redirect(redirect) {
    this.setState({ redirect });
  }

  scrollTo(elementId) {
    const el = document.getElementById(elementId);
    console.log(`--scroll to ${elementId}`)
    console.log(el)
    el?.scrollIntoView({ behavior: 'smooth' });
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />;
    }

    return (
      <div className="Page LandingPage">

        {/*
        <ul className='NavigationBar'>
          <li><img src={EdianLogo} /></li>
          <li className='NavigationBarGrowItem'>Edian Software</li>
          <li onClick={e => this.scrollTo('testimonials')}>Testimonials</li>
        </ul>
        */}

        <div className="PageBlockWhite">
          <p>
            <img src={EdianLogo} className='EdianLogo' />
          </p>
          <p>
            <h1>Edian Software</h1> is a technology consultancy based out of South Africa, </p>
          <p>
            We are dedicated to empowering small businesses through innovative digital solutions. Rather than positioning ourselves as a traditional software consultancy, we see ourselves as product partners, collaborating closely with our clients to bring their visions to life.
          </p>
          <p>
            We are passionate about exploring new ideas and leveraging world-class technologies, including artificial intelligence and other rapidly evolving tools, to help companies not just survive but thrive in today’s fast-changing technological landscape. Our focus is on nurturing young, creative concepts, while relying on a solid, battle-tested skillset honed through years of experience.
          </p>
        </div>

        <div className="PageBlock">
          <div className='PageBlockWhiteHalf'>
            <h1>GIZMO-DOCS</h1>
            <h2>Digital Asset Management</h2>
            <p>AWS managed services applied to the domain of digital assets and multi media.</p>
            <p className='PageTechnologies'>
              <img src={AwsLogo} />
              <img src={OllamaLogo} />
            </p>
          </div>
          <div className='PageBlockTransparentHalf'>
            <img className="TalentFitScreenshot" src={GizmoDocs01} />
            <img className="TalentFitScreenshot" src={GizmoDocs02} />
          </div>

        </div>

        <div className="PageBlock">
          <div className='PageBlockTransparentHalf'>
            <img className="TalentFitScreenshot" src={WarGauge01} />
            <img className="TalentFitScreenshot" src={WarGauge02} />
          </div>
          <div className='PageBlockWhiteHalf'>
            <h1>WAR-GAUGE</h1>
            <h2>Cloud Architecture</h2>
            <p>Tooling for performing Well Architected Reviews, remediating issues and producing artifacts including diagrams.</p>
            <p className='PageTechnologies'>
              <img src={AwsLogo} />
              <img src={HashicorpLogo} />
              <img src={OllamaLogo} />
            </p>
          </div>
        </div>

        <div className="PageBlock">
          <div className="PageBlockWhiteHalf">
            <h1>TALENT-FIT</h1>
            <h2>Recruitment</h2>
            <p>A new, more cost effective take on supporting recruitment efforts.</p>
            <p className='PageTechnologies'>
              <img src={AwsLogo} />
              <img src={AndroidLogo} />
              <img src={IosLogo} />
              <img src={ReactLogo} />
              <img src={OllamaLogo} />
            </p>
          </div>
          <div className='PageBlockTransparentHalf'>
            <img className="TalentFitScreenshotMobile" src={TalentFit01} />
            <img className="TalentFitScreenshotMobile" src={TalentFit02} />
          </div>
        </div>

        <div className="PageBlock">
          <div className='PageBlockTransparentHalf'>
            <img className="TalentFitScreenshot" src={Orbiter02} />
            <img className="TalentFitScreenshot" src={Orbiter01} />
          </div>
          <div className='PageBlockWhiteHalf'>
            <h1>ORBITER</h1>
            <h2>Aerospace</h2>
            <p>Manages the reservation of satellite overpasses and related workflows.</p>
            <p className='PageTechnologies'>
              <img src={AwsLogo} />
              <img src={ReactLogo} />
            </p>
          </div>
        </div>


        <div className="PageBlockWhite">

          <p>By harnessing world-class methodologies, robust infrastructure, and cutting-edge technologies, we ensure that every solution we deliver is built on a foundation of proven expertise. Our team is grounded in well-understood, globally recognized best practices—combining deep technical knowledge with a commitment to quality and reliability. This approach allows us to confidently navigate new challenges, adapt to emerging trends, and consistently deliver results that meet the highest international standards.</p>

          <p className='PageTechnologies'>
            <img src="https://edian.io/assets/aws_cpf.png" />
            <img src="https://edian.io/assets/aws_aif.png" />
            <img src="https://edian.io/assets/aws_saa.png" />
            <img src="https://edian.io/assets/aws_da.png" />
            <img src="https://edian.io/assets/aws_mla.png" />
            <img src="https://edian.io/assets/aws_sysaa.png" />
            <img src="https://edian.io/assets/aws_data_associate.png" />
            <img src="https://edian.io/assets/aws_sap.png" />
            <img src="https://edian.io/assets/aws_dep.png" />
            <img src="https://edian.io/assets/aws_mls.png" />
            <img src="https://edian.io/assets/aws_ss.png" />
            <img src="https://edian.io/assets/aws_das.webp" />
            <img src="https://edian.io/assets/aws_database.webp" />
            <img src="https://edian.io/assets/aws_nws.png" />

            <img src="https://edian.io/assets/hashicorp_terraform.png" />
          </p>

          <p>
            <a href='mailto:info@edian.io'>info@edian.io</a>
          </p>
          <p>© Edian Software 2025. All rights reserved.</p>
        </div>
      </div >
    );
  }
}

const mapStateToProps = (state) => ({
  session: state.session,
});

const mapDispatchToProps = () => ({
  updateSession,
  clearSession,
});

export default connect(mapStateToProps, mapDispatchToProps())(LandingPage);
